// extracted by mini-css-extract-plugin
export var text = "_67-0";